var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat302(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_302"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_302",
    "data-name": 302,
    className: "cls-2",
    d: "M19.82,42.86c-3.33,15.32-5.36,35.24,7.83,46.7,11.89,10.32,31.19,9.81,44.65,3,11.27-5.73,16.43-16.78,15-29.29C85.18,45.58,72.14,2.07,49,2,34.53,1.9,23.28,27,19.82,42.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat302);
export default __webpack_public_path__ + "static/media/cat_302.821697f4840b6050733fadf9744acc5b.svg";
export { ForwardRef as ReactComponent };